/**
 * Navigation Configuration
 * Central configuration for all navigation menu items
 * This makes it easy to maintain and add translations later
 */

export interface NavigationItem {
  id: string
  label: string
  path: string
  icon: string // SVG path data
  matchPath?: (path: string) => boolean // Custom path matching logic
}

/**
 * Main navigation menu items
 * These are displayed in both desktop and mobile headers
 */
export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    id: 'home',
    label: 'Dashboard',
    path: '/home',
    icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6',
    matchPath: (path) => path === '/home'
  },
  {
    id: 'meals',
    label: 'Meals',
    path: '/meals',
    icon: 'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253'
  },
  {
    id: 'recipes',
    label: 'Recipes',
    path: '/recipes',
    icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z'
  },
  {
    id: 'shopping-lists',
    label: 'Shopping Lists',
    path: '/shopping-lists',
    icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2M9 12h6M9 16h6'
  }
]

/**
 * Check if a navigation item is active based on current route path
 */
export const isNavigationItemActive = (item: NavigationItem, currentPath: string): boolean => {
  if (item.matchPath) {
    return item.matchPath(currentPath)
  }
  return currentPath === item.path
}
